import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/members/src/components/PageLayout/BasicPageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/members/src/ui/pages/faq/Faqs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/members/src/ui/pages/faq/WelcomeVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/box/index.js");
